import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { fontDisplay, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 6,

        '& > :only-child': {
          alignSelf: 'flex-start',
        },
      },
    },
    sortSelectWrapper: {
      display: 'flex',
      gap: 4,
      alignItems: 'center',
      whiteSpace: 'nowrap',
    },
    additionalElement: {
      marginLeft: 8,
    },
    sortSelect: {
      marginLeft: 4,
      color: theme.color.greys[80],
      font: fontDisplay('normal', theme.fontSize.s, 16),
    }
  }),
  { name: 'SortPanel', index: StylesIndexInjections.OTHER }
);
